/**
 * containerPrivacy — the ONE privacy-class chip vocabulary for connector
 * containers (YAG-263). Shared by the Connections container list and the team
 * settings grant picker so a "private" chip reads identically everywhere:
 * public → Workspace (success), private/shared → warning, unknown → Classifying
 * (neutral, still fail-closed server-side).
 */

export type ContainerPrivacyClass = "public" | "private" | "shared" | "unknown";

export interface PrivacyBadge {
  label: string;
  variant: "success" | "warning" | "neutral";
}

export const PRIVACY_BADGE: Record<ContainerPrivacyClass, PrivacyBadge> = {
  public: { label: "Workspace", variant: "success" },
  private: { label: "Private", variant: "warning" },
  shared: { label: "Shared", variant: "warning" },
  unknown: { label: "Classifying", variant: "neutral" },
};
